if (process.env.NODE_ENV !== 'production') {
  import('./devImports.js')
}
import Vue from 'vue';
import App from '@/App.vue';
import store from '@/store';
import TagManager from '@/services/TagManager';
import '@/plugins'
import VueCookies from 'vue-cookies'

Vue.prototype.$gtag = TagManager.init(process.env.NODE_ENV);
Vue.config.productionTip = false;

Vue.use(VueCookies);
Vue.$cookies.config('30d')

new Vue({
  store,
  render: h => h(App),
}).$mount('#app');
